export const brandColors = {
    'brand-red': '#ff0000',
    'brand-blue': '#00003c',
};

export const uiColors = {
    blue: '#3367d6',
    green: '#149436',
    orange: '#f49b12',
    yellow: '#e7e738',
    red: brandColors['brand-red'],
};

export const lightUiColors = {
    'green-light': '#E0F1E5',
    'orange-light': '#fef2e0',
    'red-light': '#f7dee4',
    'brand-blue-light': '#4D4D77',
    'blue-light': '#BEE0FF',
};

export const shadesOfGray = {
    'gray-darkest': '#404040',
    'gray-border': '#9f9f9f',
    gray: '#e3e3e3',
    'gray-light': '#dedede',
    'gray-lightest': '#f3f3f3',
};

export default {
    ...brandColors,
    ...uiColors,
    ...lightUiColors,
    ...shadesOfGray,
};
